import { useEffect, useRef } from 'react';
import { AndroidBackButton, BackHandler } from '../services/Utils/AndroidBackButton';

/**
 * 안드로이드 하드웨어 백버튼 핸들러 등록 훅
 *
 * enabled 인 동안 AndroidBackButton 레지스트리에 핸들러를 등록한다.
 * 핸들러가 true 를 반환하면 이벤트가 소비되어 기본 동작(두 번 눌러 종료)이
 * 실행되지 않는다. 웹/iOS 에서는 'backButton' 네이티브 이벤트 자체가 발생하지
 * 않으므로 등록해도 아무 효과가 없다(no-op).
 *
 * 사용 예 — 상세 오버레이가 열려 있는 동안 백버튼으로 목록 복귀:
 *   useAndroidBackHandler(!!selectedPost, () => { closeDetail(); return true; });
 */
export function useAndroidBackHandler(enabled: boolean, handler: BackHandler) {
  // 최신 핸들러를 ref 로 유지 — 핸들러 함수가 매 렌더 바뀌어도 재등록하지 않는다
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) return;
    return AndroidBackButton.register(() => handlerRef.current());
  }, [enabled]);
}
